import './GeneralOptionDrag.css';
import questionIcon from '../images/question.png';
const GeneralOptionDrag = ({
  question,
  options = [],
  answers = [],
  isAnswerChecked = false,
  onAnswersChange,
  getOptionValueById,
  showQuestion = true,
   insideSimpleApplication = false,
}) => {
  if (!question) {
    return null;
  }

  const rows =
    Array.isArray(question.rows) &&
    question.rows.length > 0
      ? question.rows
      : [];

  const slotsCount = rows.reduce(
    (total, row) => {
      const rowSlots = Number(row?.slots);

      return (
        total +
        (
          Number.isFinite(rowSlots) &&
          rowSlots > 0
            ? rowSlots
            : 0
        )
      );
    },
    0
  );

  const safeAnswers =
    Array.isArray(answers) &&
    answers.length === slotsCount
      ? answers
      : Array(slotsCount).fill(null);

  const expectedAnswers =
  Array.isArray(question.correctAnswer)
    ? question.correctAnswer
    : [];

const answerMode = [
  'ordered',
  'unordered',
  'unorderedPerRow',
].includes(question.answerMode)
  ? question.answerMode
  : 'ordered';

const normalizeAnswer = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase();

const expectedAnswerCounts =
  expectedAnswers.reduce(
    (counts, answer) => {
      const normalizedAnswer =
        normalizeAnswer(answer);

      counts[normalizedAnswer] =
        (counts[normalizedAnswer] || 0) + 1;

      return counts;
    },
    {}
  );



  const getRowRangeBySlotIndex = (
  slotIndex
) => {
  let startIndex = 0;

  for (const row of rows) {
    const rowSlots = Math.max(
      0,
      Number(row?.slots) || 0
    );

    const endIndex =
      startIndex + rowSlots;

    if (
      slotIndex >= startIndex &&
      slotIndex < endIndex
    ) {
      return {
        startIndex,
        endIndex,
      };
    }

    startIndex = endIndex;
  }

  return {
    startIndex: 0,
    endIndex: slotsCount,
  };
};


  const updateAnswers = (nextAnswers) => {
    onAnswersChange?.(nextAnswers);
  };

  const readDraggedOptionId = (event) => {
    try {
      const payload =
        event.dataTransfer.getData(
          'application/json'
        );

      if (payload) {
        const parsedPayload =
          JSON.parse(payload);

        if (parsedPayload?.id) {
          return parsedPayload.id;
        }
      }
    } catch (error) {
      // fallback pe text/plain
    }

    return event.dataTransfer.getData(
      'text/plain'
    );
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleOptionDragStart = (
    event,
    optionId
  ) => {
    if (
      isAnswerChecked ||
      !optionId
    ) {
      return;
    }

    event.dataTransfer.setData(
      'application/json',
      JSON.stringify({
        id: optionId,
      })
    );

    event.dataTransfer.setData(
      'text/plain',
      String(optionId)
    );

    event.dataTransfer.effectAllowed =
      'move';
  };

  const placeOptionInSlot = (
    slotIndex,
    optionId
  ) => {
    if (
      isAnswerChecked ||
      !optionId
    ) {
      return;
    }

    const nextAnswers = [
      ...safeAnswers,
    ];

    const previousSlotIndex =
      nextAnswers.indexOf(optionId);

    if (previousSlotIndex !== -1) {
      nextAnswers[previousSlotIndex] =
        null;
    }

    nextAnswers[slotIndex] = optionId;

    updateAnswers(nextAnswers);
  };

  const handleDropOnSlot = (
    event,
    slotIndex
  ) => {
    event.preventDefault();

    const optionId =
      readDraggedOptionId(event);

    if (!optionId) {
      return;
    }

    placeOptionInSlot(
      slotIndex,
      optionId
    );
  };

  const removeOptionFromSlot = (
    slotIndex
  ) => {
    if (isAnswerChecked) {
      return;
    }

    const nextAnswers = [
      ...safeAnswers,
    ];

    nextAnswers[slotIndex] = null;

    updateAnswers(nextAnswers);
  };

  const handleOptionClick = (
    optionId
  ) => {
    if (isAnswerChecked) {
      return;
    }

    const firstEmptySlot =
      safeAnswers.findIndex(
        (answer) =>
          answer === null ||
          answer === undefined ||
          answer === ''
      );

    if (firstEmptySlot === -1) {
      return;
    }

    placeOptionInSlot(
      firstEmptySlot,
      optionId
    );
  };

  const handleDropOnOptions = (event) => {
    event.preventDefault();

    if (isAnswerChecked) {
      return;
    }

    const optionId =
      readDraggedOptionId(event);

    if (!optionId) {
      return;
    }

    const nextAnswers =
      safeAnswers.map((answer) =>
        answer === optionId
          ? null
          : answer
      );

    updateAnswers(nextAnswers);
  };

const isSlotAnswerCorrect = (
  slotIndex,
  optionValue
) => {
  if (!optionValue) {
    return false;
  }

  const normalizedOptionValue =
    normalizeAnswer(optionValue);

  if (answerMode === 'ordered') {
    return (
      normalizedOptionValue ===
      normalizeAnswer(
        expectedAnswers[slotIndex]
      )
    );
  }

  if (
    answerMode ===
    'unorderedPerRow'
  ) {
    const {
      startIndex,
      endIndex,
    } =
      getRowRangeBySlotIndex(
        slotIndex
      );

    const expectedRowAnswers =
      expectedAnswers
        .slice(
          startIndex,
          endIndex
        )
        .map(normalizeAnswer);

    const expectedRowCounts =
      expectedRowAnswers.reduce(
        (counts, answer) => {
          counts[answer] =
            (counts[answer] || 0) + 1;

          return counts;
        },
        {}
      );

    const previousOccurrences =
      safeAnswers
        .slice(
          startIndex,
          slotIndex
        )
        .map((answerId) =>
          getOptionValueById?.(
            question,
            answerId
          )
        )
        .filter(
          (answer) =>
            normalizeAnswer(answer) ===
            normalizedOptionValue
        ).length;

    return (
      previousOccurrences <
      (expectedRowCounts[
        normalizedOptionValue
      ] || 0)
    );
  }

  const previousOccurrences =
    safeAnswers
      .slice(0, slotIndex)
      .map((answerId) =>
        getOptionValueById?.(
          question,
          answerId
        )
      )
      .filter(
        (answer) =>
          normalizeAnswer(answer) ===
          normalizedOptionValue
      ).length;

  return (
    previousOccurrences <
    (expectedAnswerCounts[
      normalizedOptionValue
    ] || 0)
  );
};

const getSlotClassName = (
  slotIndex,
  optionValue
) => {
  const classes = [
    'decision-dnd-slot-bc',
  ];

  if (optionValue) {
    classes.push('filled');
  }

  if (
    isAnswerChecked &&
    optionValue
  ) {
    if (
      isSlotAnswerCorrect(
        slotIndex,
        optionValue
      )
    ) {
      classes.push('correct');
    } else {
      classes.push('incorrect');
    }
  }

  return classes.join(' ');
};

  const renderSlot = (slotIndex) => {
    const optionId =
      safeAnswers[slotIndex] ?? null;

    const optionValue =
      getOptionValueById?.(
        question,
        optionId
      ) ?? '';

    return (
      <button
        key={`general-slot-${slotIndex}`}
        type="button"
        className={getSlotClassName(
          slotIndex,
          optionValue
        )}
        onDragOver={handleDragOver}
        onDrop={(event) =>
          handleDropOnSlot(
            event,
            slotIndex
          )
        }
        onClick={() =>
          removeOptionFromSlot(
            slotIndex
          )
        }
        draggable={
          !isAnswerChecked &&
          Boolean(optionId)
        }
        onDragStart={(event) => {
          if (optionId) {
            handleOptionDragStart(
              event,
              optionId
            );
          }
        }}
        disabled={isAnswerChecked}
      >
        {optionValue && (
          <span className="decision-dnd-slot-bc-filled-style">
            {String(optionValue)}
          </span>
        )}
      </button>
    );
  };

  let currentSlotIndex = 0;

return (
  <div className="general-option-drag">

  <div
  className={
    insideSimpleApplication
      ? ''
      : 'quiz-content-scroll-bc'
  }
>

      <div className="explanation-lesoon-container-bc">

   {showQuestion && question.question && (
  <div className="simple-application-question">
    <img
      src={questionIcon}
      alt="Question"
      className="simple-application-question-icon"
    />

    <p>{question.question}</p>
  </div>
)}
        <div className="decision-dnd-container-bc">
          {rows.map((row, rowIndex) => {
            const rowSlots = Math.max(
              0,
              Number(row?.slots) || 0
            );

            const rowStartIndex =
              currentSlotIndex;

            currentSlotIndex += rowSlots;

            return (
              <div
                key={`general-row-${rowIndex}`}
                className="decision-dnd-row-bc"
              >
                {row?.label && (
                  <p className="decision-dnd-row-label-bc">
                    {row.label}
                  </p>
                )}

                <div className="decision-dnd-row-slots-bc">
                  {Array.from(
                    {
                      length: rowSlots,
                    },
                    (_, index) =>
                      renderSlot(
                        rowStartIndex + index
                      )
                  )}
                </div>
              </div>
            );
          })}
        </div>

      <div
  className={[
    'decision-dnd-options-bc',
    isAnswerChecked
      ? 'decision-dnd-options-hidden-bc'
      : '',
  ]
    .filter(Boolean)
    .join(' ')}
  onDragOver={handleDragOver}
  onDrop={handleDropOnOptions}
>
  {options.map((option) => {
    const isUsed =
      safeAnswers.includes(option.id);

    return (
      <button
        key={option.id}
        type="button"
        className={[
          'decision-dnd-option-bc',
          isUsed ? 'used' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        draggable={
          !isAnswerChecked && !isUsed
        }
        disabled={
          isAnswerChecked || isUsed
        }
        onDragStart={(event) => {
          if (
            !isAnswerChecked &&
            !isUsed
          ) {
            handleOptionDragStart(
              event,
              option.id
            );
          }
        }}
        onClick={() => {
          if (
            !isAnswerChecked &&
            !isUsed
          ) {
            handleOptionClick(
              option.id
            );
          }
        }}
      >
        {!isUsed && option.label}
      </button>
    );
  })}
</div>

      </div>
</div>
   

  </div>
);
};

export default GeneralOptionDrag;